export enum MediaBankStorageType {
    Azure = 0, // todo rename to Upcloud
    Vimeo = 1,
}
